import React, { useState, useEffect, useRef } from "react";
import {
  ChatBubble,
  Handyman,
  Close,
  Send,
  DeleteOutline,
} from "@mui/icons-material";
import { API_ENDPOINT } from "../../services/api/resources";
import { useSelector } from "react-redux";
import styles from "./ChatBot.module.css";
import { ACTION_PERMISSION_MAP } from "./permissionMap";

const KEYWORD_SUGGESTIONS = {
  // RFQ RELATED

  rfq: { label: "RFQ Automation", action: "navigate_to_rfq_automation" },
  quotation: { label: "RFQ Automation", action: "navigate_to_rfq_automation" },
  quote: { label: "RFQ Automation", action: "navigate_to_rfq_automation" },
  "request for quote": {
    label: "RFQ Automation",
    action: "navigate_to_rfq_automation",
  },

  // QUICK RFQ
  "quick rfq": { label: "Quick RFQ", action: "navigate_to_quick_rfq" },
  "fast rfq": { label: "Quick RFQ", action: "navigate_to_quick_rfq" },
  "instant rfq": { label: "Quick RFQ", action: "navigate_to_quick_rfq" },

  // PO RELATED

  po: { label: "PO Automation", action: "navigate_to_po_automation" },
  "purchase order": {
    label: "PO Automation",
    action: "navigate_to_po_automation",
  },
  order: { label: "PO Automation", action: "navigate_to_po_automation" },

  // PR RELATED

  pr: { label: "PR Automation", action: "navigate_to_pr_automation" },
  "purchase request": {
    label: "PR Automation",
    action: "navigate_to_pr_automation",
  },
  request: { label: "PR Automation", action: "navigate_to_pr_automation" },

  // INVOICE RELATED

  invoice: {
    label: "Merchant Invoice Automation",
    action: "navigate_to_merchant_invoice_automation",
  },
  bill: {
    label: "Merchant Invoice Automation",
    action: "navigate_to_merchant_invoice_automation",
  },
  payment: {
    label: "Merchant Invoice Automation",
    action: "navigate_to_merchant_invoice_automation",
  },
  billing: {
    label: "Merchant Invoice Automation",
    action: "navigate_to_merchant_invoice_automation",
  },

  // VENDOR RELATED

  vendor: { label: "Vendor Master", action: "navigate_to_vendor_master" },
  supplier: { label: "Vendor Master", action: "navigate_to_vendor_master" },
  party: { label: "Vendor Master", action: "navigate_to_vendor_master" },
  onboard: { label: "Vendor Onboarding", action: "navigate_to_onboarding" },

  // BID RELATED

  bid: { label: "Bid Submission", action: "navigate_to_vendor_bid_submission" },
  tender: {
    label: "Bid Submission",
    action: "navigate_to_vendor_bid_submission",
  },
  "submit price": {
    label: "Bid Submission",
    action: "navigate_to_vendor_bid_submission",
  },

  // GRN RELATED

  grn: { label: "GRN Automation", action: "navigate_to_grn_automation" },
  "goods receipt": {
    label: "GRN Automation",
    action: "navigate_to_grn_automation",
  },
  "material received": {
    label: "GRN Automation",
    action: "navigate_to_grn_automation",
  },

  // MRP RELATED

  mrp: {
    label: "Material Requirement Planning",
    action: "navigate_to_material_requirement_planning",
  },
  planning: {
    label: "Material Requirement Planning",
    action: "navigate_to_material_requirement_planning",
  },
  "material plan": {
    label: "Material Requirement Planning",
    action: "navigate_to_material_requirement_planning",
  },

  // MATCHING RELATED

  matching: {
    label: "Three Way Matching",
    action: "navigate_to_three_way_matching",
  },
  "3 way": {
    label: "Three Way Matching",
    action: "navigate_to_three_way_matching",
  },
  "three way": {
    label: "Three Way Matching",
    action: "navigate_to_three_way_matching",
  },
  "match invoice": {
    label: "Three Way Matching",
    action: "navigate_to_three_way_matching",
  },

  // RATE CONTRACT

  rate: { label: "Rate Contract", action: "navigate_to_rate_contract" },
  contract: { label: "Rate Contract", action: "navigate_to_rate_contract" },

  // ITEM MASTER

  item: { label: "Item Master", action: "navigate_to_item_master" },
  product: { label: "Item Master", action: "navigate_to_item_master" },
  material: { label: "Item Master", action: "navigate_to_item_master" },

  // COMPARISON AUTOMATION

  compare: {
    label: "Comparison Automation",
    action: "navigate_to_comparison_automation",
  },
  comparison: {
    label: "Comparison Automation",
    action: "navigate_to_comparison_automation",
  },

  // COMPLIANCE

  compliance: {
    label: "Vendor Compliance Verification",
    action: "navigate_to_vendor_compliance_verification",
  },
  "verify vendor": {
    label: "Vendor Compliance Verification",
    action: "navigate_to_vendor_compliance_verification",
  },

  // DASHBOARD

  dashboard: { label: "Dashboard", action: "navigate_to_dashboard" },
  home: { label: "Dashboard", action: "navigate_to_dashboard" },

  // USER RELATED

  approval: {
    label: "Onboarding Approval",
    action: "navigate_to_user_onboarding_approval",
  },
  approve: {
    label: "Onboarding Approval",
    action: "navigate_to_user_onboarding_approval",
  },
};

const extractPRCode = (message) => {
  const prRegex = /\bPR-\d+\b/i;
  const match = message.match(prRegex);
  return match ? match[0] : null;
};

// const extractVendorSearchText = (message) => {
//   const words = message.toLowerCase().split(/\s+/);

//   const vendorIndex = words.findIndex(
//     (w) => w === "vendor" || w === "supplier"
//   );

//   if (vendorIndex === -1) return null;

//   const searchText = words
//     .slice(vendorIndex + 1)
//     .join(" ")
//     .trim();
//   return searchText || null;
// };

const extractRFQCode = (message) => {
  const regex = /\b([A-Z]+(?:-[A-Z]+)?[_-]?\d+)\b/i;
  const match = message.match(regex);
  return match ? match[0] : null;
};

const extractPOSearchValue = (message) => {
  const match = message.match(/\b(?:po|pr)\s+([a-zA-Z0-9_-]+)\b/i);
  return match ? match[1] : null;
};

const extractUserSearchText = (message) => {
  const match = message.match(/\buser[s]?\s+(.+)/i);
  return match ? match[1].trim() : null;
};

const extractVendorUSerSearch = (message) => {
  const match = message.match(/\buser[s]?\s+(.+)/i);
  return match ? match[1].trim() : null;
};

const extractVendorMasterSearch = (message) => {
  if (typeof message !== "string") return null;

  const stopWords = new Set([
    "open",
    "show",
    "get",
    "find",
    "search",
    "lookup",
    "view",
    "details",
    "profile",
    "information",
    "please",
    "can",
    "you",
    "for",
    "of",
    "the",
    "a",
    "an",
    "vendor", // ✅ IMPORTANT
    "vendors", // ✅ IMPORTANT
  ]);

  const words = message
    .toLowerCase()
    .replace(/[^\w\s]/g, "")
    .split(/\s+/)
    .filter(Boolean);

  const result = [];
  for (let i = words.length - 1; i >= 0; i--) {
    if (stopWords.has(words[i])) break;
    result.unshift(words[i]);
  }

  return result.length ? result.join(" ") : null;
};

const extractInvoiceOrPONumber = (message) => {
  if (typeof message !== "string") return null;

  // Match any structured identifier (letters + numbers)
  const regex =
    /\b[A-Z]{1,10}\d+|\b\d+[A-Z]{1,10}|\b[A-Z0-9]+(?:[-_/][A-Z0-9]+)+\b/i;

  const match = message.match(regex);
  return match ? match[0].trim() : null;
};

const extractMasterSearch = (message) => {
  if (typeof message !== "string") return null;

  const MASTER_KEYS = ["item", "tax", "cost center", "gl code", "user"];

  const text = message
    .toLowerCase()
    .replace(/[^\w\s]/g, "")
    .trim();

  for (const key of MASTER_KEYS) {
    const regexKey = key.replace(/\s+/g, "\\s+");
    const regex = new RegExp(`\\b${regexKey}\\b(?:\\s+(.+))?`);
    const match = text.match(regex);

    if (match) {
      return {
        masterKey: key,
        searchText: match[1] ? match[1].trim() : null,
      };
    }
  }

  return null;
};

const extractThreeWaySearchText = (message) => {
  if (typeof message !== "string") return null;

  // Remove intent / noise words
  const cleaned = message
    .toLowerCase()
    .replace(/[^\w\s/.-]/g, "")
    .replace(
      /\b(search|find|lookup|filter|show|get|records?|record|data|matching|match|by|for|of|the|a|an)\b/g,
      ""
    )
    .trim();

  if (!cleaned) return null;

  // Split words
  const words = cleaned.split(/\s+/);

  // Take last meaningful chunk (1–6 words)
  const searchText = words.slice(-6).join(" ").trim();

  return searchText || null;
};

const extractApproverRangeMasterSearch = (message) => {
  if (typeof message !== "string") return null;

  const text = message
    .toLowerCase()
    .replace(/[^\w\s]/g, "")
    .trim();

  // Must be approver-related
  if (!/(approver|approval)/.test(text)) return null;

  const APPROVER_MASTER_KEYS = [
    { key: "pr", aliases: ["pr", "purchase request"] },
    { key: "po", aliases: ["po", "purchase order"] },
    {
      key: "twm",
      aliases: ["twm", "three way matching", "invoice matching", "3 way"],
    },
  ];

  for (const master of APPROVER_MASTER_KEYS) {
    if (master.aliases.some((a) => text.includes(a))) {
      // Capture everything after "approver range"
      const match = text.match(/approver\s+range\s*(.+)?$/);

      return {
        masterKey: master.key,
        searchText: match?.[1]?.trim() || null,
      };
    }
  }

  return null;
};

const extractGrnSearchText = (message) => {
  if (typeof message !== "string") return null;

  const cleaned = message
    .toLowerCase()
    .replace(/[^\w\s/.-]/g, "") // keep numbers & refs
    .replace(
      /\b(search|find|lookup|view|show|filter|grn|grns|goods|receipt|note|by|for|of|the|a|an|open|pending|number)\b/g,
      ""
    )
    .trim();

  if (!cleaned) return null;

  // take last meaningful chunk (safe for names & numbers)
  const words = cleaned.split(/\s+/);
  const searchText = words.slice(-6).join(" ").trim();

  return searchText || null;
};

const extractComparisonSearch = (message) => {
  if (typeof message !== "string") return null;
  const matches = message.match(/\d+/g);
  return matches ? matches[matches.length - 1] : null;
};

const ChatWidget = () => {
  const clearChatURLParams = () => {
    const hash = window.location.hash;
    const baseRoute = hash.split("?")[0];
    window.history.replaceState(null, "", baseRoute);
  };
  const data = useSelector((state) => state.loginData.value);
  const access_type = data?.access_type;
  const user_token = data?.user?.user_token;
  const allowedMenu = useSelector(
    (state) => state.loginData.value?.allowed_menu || []
  );

  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    {
      sender: "bot",
      text: "👋 Hi! I'm your Bidz Assistant. How can I help you today?",
    },
  ]);
  const [input, setInput] = useState("");
  const [isBotTyping, setIsBotTyping] = useState(false);

  const chatRef = useRef(null);
  const messagesEndRef = useRef(null);

  const toggleWidget = () => setIsOpen((prev) => !prev);

  // Scroll to bottom of messages
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  // Simulate bot typing
  const showBotReply = (replyText) => {
    setIsBotTyping(true);
    setTimeout(() => {
      setMessages((prev) => [...prev, { sender: "bot", text: replyText }]);
      setIsBotTyping(false);
    }, 1200);
  };

  const botReply = (text) => {
    setMessages((prev) => [...prev, { sender: "bot", text }]);
  };

  const handleSend = async () => {
    if (!input.trim() || isBotTyping) return;

    const userMessage = input.trim();
    setMessages((prev) => [...prev, { sender: "user", text: userMessage }]);
    setInput("");
    setIsBotTyping(true);

    try {
      const res = await fetch(`${API_ENDPOINT.user_chat_bot_message}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          message: userMessage,
          user_token: user_token,
          access_type: access_type,
        }),
      });

      const data = await res.json();
      setIsBotTyping(false);

      if (data.type === "menu") {
        setMessages((prev) => [
          ...prev,
          {
            sender: "bot",
            type: "menu",
            menus: data.menus,
            text: data.text || "Here are your available options:",
          },
        ]);
        return;
      }
      const prCodeFromMessage = extractPRCode(userMessage);
      const rfqCodeFromMessage = extractRFQCode(userMessage);
      const poSearchValue = extractPOSearchValue(userMessage);
      const frontendSuggest = findFrontendSuggestion(userMessage);
      const userSearchText = extractUserSearchText(userMessage);
      const vendorUserSearchText = extractVendorUSerSearch(userMessage);
      const invoiceProcessSearch = extractInvoiceOrPONumber(userMessage);
      const vendorMasterSearchText = extractVendorMasterSearch(userMessage);
      const masterSearch = extractMasterSearch(userMessage);
      const ApproverRangeSearch = extractApproverRangeMasterSearch(userMessage);
      const threeWaySearch = extractThreeWaySearchText(userMessage);
      const comparisonSearch = extractComparisonSearch(userMessage);
      const GRNSearch = extractGrnSearchText(userMessage);

      if (frontendSuggest) {
        setMessages((prev) => [
          ...prev,
          {
            sender: "bot",
            type: "suggestion",
            text: "I found something related!",
            label: frontendSuggest.label,
            action: frontendSuggest.action,
          },
        ]);
        setIsBotTyping(false);
        return;
      }

      setMessages((prev) => [
        ...prev,
        {
          sender: "bot",
          text:
            data.response ||
            "I apologize, I didn't quite understand that. Could you please rephrase?",
        },
      ]);

      if (data.action) {
        redirection_function({
          action: data.action,
          status: data.status,
          pr_code: prCodeFromMessage,
          rfq_code: rfqCodeFromMessage,
          po_code: poSearchValue,
          search_text: userSearchText,
          invoice_process_code: invoiceProcessSearch,
          vendor_user_search: vendorUserSearchText,
          vendor_Master_search: vendorMasterSearchText,
          buyerAdmin_master_search: masterSearch,
          buyerAdmin_approverRange_search: ApproverRangeSearch,
          three_way_search: threeWaySearch,
          comparison_search: comparisonSearch,
          grn_search: GRNSearch,
        });
      }
    } catch (error) {
      console.error("Chatbot error:", error);
      setIsBotTyping(false);
      setMessages((prev) => [
        ...prev,
        {
          sender: "bot",
          text: " Sorry, I'm having trouble connecting right now. Please try again in a moment.",
        },
      ]);
    }
  };

  const findFrontendSuggestion = (message) => {
    const msg = message.toLowerCase().trim();

    for (let key in KEYWORD_SUGGESTIONS) {
      if (msg === key.toLowerCase()) {
        return KEYWORD_SUGGESTIONS[key];
      }
    }

    return null;
  };

  const normalizedAccess = (() => {
    const role = String(access_type || "")
      .trim()
      .toLowerCase();

    if (role.includes("vendor")) return "vendor";
    if (role === "admin") return "buyer_admin";
    if (role.includes("buyer")) return "buyer";
    if (role.includes("user")) return "user";

    return role;
  })();

  const redirection_function = ({
    action,
    pr_code,
    rfq_code,
    po_code,
    search_text,
    invoice_process_code,
    vendor_user_search,
    vendor_Master_search,
    buyerAdmin_master_search,
    buyerAdmin_approverRange_search,
    status,
    three_way_search,
    comparison_search,
    grn_search,
  }) => {
    const config = ACTION_PERMISSION_MAP[action];

    if (!config) {
      botReply("❌ You do not have permission for this module.");
      return;
    }

    // Menu-based validation ONLY for Buyer & Buyer Admin
    if (
      ["buyer", "buyer_admin"].includes(normalizedAccess) &&
      !allowedMenu.includes(config.menuId)
    ) {
      botReply("❌ You do not have access for this module.");
      return;
    }

    const route = config[normalizedAccess];

    if (!route) {
      botReply("❌ Access denied for your role.");
      return;
    }

    sessionStorage.setItem(
      "CHAT_ACTION",
      JSON.stringify({
        action,
        pr_code,
        rfq_code,
        po_code,
        search_text,
        invoice_process_code,
        vendor_user_search,
        vendor_Master_search,
        buyerAdmin_master_search,
        buyerAdmin_approverRange_search,
        status,
        three_way_search,
        comparison_search,
        grn_search,
      })
    );

    window.location.hash = "";
    setTimeout(() => {
      window.location.hash = route;
    }, 0);
  };

  // Restore from localStorage
  useEffect(() => {
    const saved = localStorage.getItem("chat_messages");
    if (saved) setMessages(JSON.parse(saved));
  }, []);

  useEffect(() => {
    localStorage.setItem("chat_messages", JSON.stringify(messages));
  }, [messages]);

  const clearChat = () => {
    // Clear chat history
    localStorage.removeItem("chat_messages");
    sessionStorage.removeItem("CHAT_ACTION");
    window.dispatchEvent(new Event("chat-cleared"));
    setMessages([
      {
        sender: "bot",
        text: "👋 Hi! I'm your Bidz Assistant. How can I help you today?",
      },
    ]);

    clearChatURLParams();
  };

  return (
    <>
      {/* Floating Button */}
      <div className={styles.chatFloatingBtn} onClick={toggleWidget}>
        <ChatBubble sx={{ fontSize: 25 }} />
      </div>

      {isOpen && (
        <div ref={chatRef} className={styles.chatWidgetContainer}>
          {/* Header */}
          <div className={styles.chatHeader}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div className={styles.chatAvatar}>
                <Handyman sx={{ fontSize: 20 }} />
              </div>
              <div>
                <div style={{ fontWeight: 600, fontSize: 16 }}>
                  Bidz Assistant
                </div>
                <div className={styles.chatStatus}>
                  {isBotTyping ? "Typing..." : "Online"}
                </div>
              </div>
            </div>

            <div style={{ display: "flex", gap: 8 }}>
              <button className={styles.chatClearBtn} onClick={clearChat}>
                <DeleteOutline sx={{ fontSize: 16 }} /> Clear
              </button>
              <Close
                className={styles.chatCloseBtn}
                onClick={() => setIsOpen(false)}
              />
            </div>
          </div>

          {/* Messages */}
          <div className={styles.chatMessages}>
            {messages.map((msg, idx) => (
              <div
                key={idx}
                className={styles.messageContainer}
                style={{
                  "--justify-content":
                    msg.sender === "bot" ? "flex-start" : "flex-end",
                }}
              >
                {msg.sender === "bot" && (
                  <div
                    className={`${styles.messageAvatar} ${styles.botAvatar}`}
                  >
                    <Handyman sx={{ fontSize: 14, color: "#fff" }} />
                  </div>
                )}

                <div className={styles.messageBubble}>
                  {msg.type === "menu" ? (
                    <div className={styles.menuContainer}>
                      <div className={styles.menuTitle}>{msg.text}</div>
                      <div className={styles.menuOptions}>
                        {msg.menus.map((menu, i) => (
                          <button
                            key={i}
                            className={styles.menuOptionBtn}
                            onClick={() =>
                              (window.location.hash = menu.menu_route)
                            }
                          >
                            {menu.menu_label}
                          </button>
                        ))}
                      </div>
                    </div>
                  ) : msg.type === "suggestion" ? (
                    <div className={styles.menuContainer}>
                      <div
                        className={styles.menuTitle}
                        style={{ fontWeight: 600 }}
                      >
                        {msg.text}
                      </div>

                      <button
                        className={styles.menuOptionBtn}
                        onClick={() =>
                          redirection_function({ action: msg.action })
                        }
                      >
                        {msg.label}
                      </button>
                    </div>
                  ) : (
                    <div
                      className={`${styles.messageContent} ${
                        msg.sender === "bot"
                          ? styles.botMessage
                          : styles.userMessage
                      }`}
                    >
                      {msg.text}
                    </div>
                  )}
                </div>

                {msg.sender === "user" && (
                  <div
                    className={`${styles.messageAvatar} ${styles.userAvatar}`}
                  >
                    U
                  </div>
                )}
              </div>
            ))}

            {isBotTyping && (
              <div
                className={styles.messageContainer}
                style={{ "--justify-content": "flex-start" }}
              >
                <div className={`${styles.messageAvatar} ${styles.botAvatar}`}>
                  <Handyman sx={{ fontSize: 14, color: "#fff" }} />
                </div>
                <div className={styles.typingDots}>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
            )}

            <div ref={messagesEndRef} />
          </div>

          {/* Input */}
          <div className={styles.chatInputContainer}>
            <div className={styles.chatInputWrapper}>
              <input
                type="text"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                placeholder="Type your message..."
                className={styles.chatInput}
                disabled={isBotTyping}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && !e.shiftKey && !isBotTyping) {
                    e.preventDefault();
                    handleSend();
                  }
                }}
              />

              <button
                className={styles.chatSendBtn}
                onClick={handleSend}
                disabled={!input.trim() || isBotTyping}
              >
                <Send sx={{ fontSize: 16 }} /> Send
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ChatWidget;
